/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { bool, string, func } from 'prop-types';
import classNames from 'clsx';

import EyeIcon from 'gfx/vector/eye-icon.svg';

import styles from './image.scss';

/**
 * This is the Image component class.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const Image = ({ url, fill, hidden, onClick }) => (
  <button
    className={classNames(styles.wrapper, {
      [styles.fill]: fill,
      [styles.hidden]: hidden,
    })}
    style={fill ? { backgroundImage: `url(${url})` } : {}}
    onClick={onClick}
  >
    {!fill && <img src={url} alt="" />}
    <div className={styles.overlay}>
      <span>
        <EyeIcon />
      </span>
    </div>
  </button>
);

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
Image.propTypes = {
  url: string.isRequired,
  fill: bool,
  hidden: bool,
  onClick: func,
};

/**
 * Set default properties.
 *
 * @type {Object}
 */
Image.defaultProps = {
  fill: false,
  hidden: false,
  onClick: () => {},
};

export default Image;
